<template>
  <div class="search-box">
    <input
      type="text"
      class="search-bar"
      placeholder="Presiona enter para buscar o realiza click fuera del campo..."
      v-model="query"
      @keyup="$emit('search-input', query)"
    />
  </div>
</template>

<script>
export default {
  name: 'Search',
  data () {
    return {
      query: ''
    }
  }
}
</script>

<style scoped>
.search-box {
  width: 100%;
  padding-top: 10px;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
}
.search-box .search-bar {
  display: block;
  width: 90%;
  padding: 15px;
  color: rgba(0, 0, 0, 0.75);
  font-size: 20px;
  appearance: none;
  border:none;
  outline: none;
  background: none;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 0px 16px 0px 16px;
  transition: 0.4s;
}
.search-box .search-bar:focus {
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 16px 0px 16px 0px;
}
</style>
